export default {
  label: '财务分析师',
  id: '0',
  children: [
    {
      label: '岗位定义',
      id: '0-1',
      children: [
        {
          label: '分析财务数据，提供决策支持',
          id: '0-1-1',
        },
      ],
    },
    {
      label: '岗位职责',
      id: '0-2',
      children: [
        {
          label: '制定和执行公司财务政策和制度，确保财务活动符合法律法规',
          id: '0-2-1',
        },
        {
          label: '参与预算编制和财务分析，为管理层提供决策支持',
          id: '0-2-2',
        },
        {
          label: '管理公司资金流动，包括现金管理、银行账户管理、资金筹措等',
          id: '0-2-3',
        }
      ],
    },
    {
      label: '技能要求',
      id: '0-3',
      children: [
        {
          label: '学历要求：大专及以上学历，财会相关专业优先',
          id: '0-3-1',
        },
        {
          label: '技能要求：熟练使用ERP系统或其他财务软件，具备良好的数据分析能力和沟通能力',
          id: '0-3-2',
        },
        {
          label: '职业素养：具有较强的责任心、保密意识和团队合作精神',
          id: '0-3-3',
        }
      ],
    },
    {
      label: '薪资情况',
      id: '0-4',
      children: [
        {
          label: '3000-5000',
          id: '0-4-1',
        },
      ],
    }
  ],
};